import { Typography, styled } from '../../../../base';

export const StyledNotificationTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
}));
